const BASE_URL = "https://support.g6techcare.com/api";

// SAVE PROFILE
export const saveProfile = async (data) => {
  const res = await fetch(`${BASE_URL}/profile/save`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return res.json();
};

// CHANGE PASSWORD
export const changePassword = async (data) => {
  const res = await fetch(`${BASE_URL}/profile/change-password`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return res.json();
};

// VERIFY OLD PASSWORD
export const verifyOldPassword = async (data) => {
  const res = await fetch(`${BASE_URL}/profile/verify-old-password`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });

  return res.json();
};